export const toPascalCase = (value: string): string =>
  value
    .replace(/[-_ ]+/g, ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');

export const toTitleCase = (value?: string): string => {
  if (value == null || value === '') return '';
  return value
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .map((word) =>
      word.length === 0
        ? word
        : word.charAt(0).toLocaleUpperCase('pl') + word.slice(1).toLocaleLowerCase('pl'),
    )
    .join(' ');
};

export function splitArray<T>(array: T[], chunkSize: number): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
}

export function generateInitials(name: string): string {
  const names = name.split(' ');
  return names
    .map((n) => n.charAt(0))
    .join('')
    .toUpperCase();
}

export const abbreviatedNumber = (val: number): string | number => {
  const s = ['', 'k', 'm', 'b', 't'];
  if (val === 0) return 0;
  const sNum = Math.floor(Math.log10(val) / 3);
  let sVal = parseFloat((sNum != 0 ? val / Math.pow(1000, sNum) : val).toPrecision(2));
  if (sVal % 1 != 0) {
    const rounded = sVal.toFixed(1);
    sVal = Number.parseFloat(rounded);
  }
  const sIndex = Math.min(s.length - 1, Math.max(0, sNum));
  return `${sVal}${s[sIndex]}`;
};

/**
 * Checks if a value is a non-empty string.
 * Returns false for null, undefined, or empty strings.
 *
 * @param value - The value to check
 * @returns true if value is a non-empty string, false otherwise
 */
export function isNonEmptyString(value: string | null | undefined): value is string {
  return value !== null && value !== undefined && value !== '';
}

/**
 * Normalizes a string for use as a translation key segment (e.g. for i18n keys).
 * Converts to lowercase and replaces whitespace with underscores.
 *
 * @param value - Raw string (e.g. "Blik Authorize")
 * @returns Normalized string (e.g. "blik_authorize")
 */
export function normalizeTranslationKey(value: string): string {
  return (value ?? '').toLowerCase().replace(/\s+/g, '_');
}
